module.exports = __webpack_public_path__ + "img/anchor-solid.4b6008ff.svg";